export default __webpack_public_path__ + "static/media/Invite-cuate.77e99e1b.svg";